import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Skin Forms
   */
  {
    //1
    label: 'Have you ever been diagnosed by a doctor with Acne?',
    field: 'diagnose',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'no',
          value: 'No'
        },
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            label:
              'Were you treated for your Acne? Did you receive treatment for your Acne?',
            type: 'radio',
            name: 'treatAcne',
            options: [
              { key: 'treatAcneNo', value: 'No' },
              {
                key: 'treatAcneYes',
                value: 'Yes',
                answer: {
                  type: 'list',
                  items: [
                    {
                      label:
                        'Please list what you were prescribed: or: Please list all the products you have tried',
                      type: 'multi_select',
                      options: [
                        {
                          //1
                          key: 'benzac',
                          value: 'Benzac Wash (Benzoyl peroxide 10%)',
                          answer: {
                            label:
                              'How effective was this (1-10 scale) should define the scale so its clear, 1 = bad, 10 = best',
                            type: 'number',
                            name: 'benzacEffect',
                            min: 1,
                            max: 10
                          }
                        },
                        {
                          //2
                          key: 'benzaclin',
                          value: 'Benzaclin (clindamycin1%+ benzoyl 5%)',
                          answer: {
                            label: 'How effective was this (1-10 scale)',
                            type: 'number',
                            name: 'benzaclinEffect',
                            min: 1,
                            max: 10
                          }
                        },
                        {
                          //3
                          key: 'clindoxyl',
                          value: 'Clindoxyl (Clindamycin  1% + benzoyl 5%)',
                          answer: {
                            label: 'How effective was this (1-10 scale)',
                            type: 'number',
                            name: 'clindoxylEffect',
                            min: 1,
                            max: 10
                          }
                        },
                        {
                          //4
                          key: 'tactuPump',
                          value: 'TactuPump (Adapalene 0.1% + benzoyl 2.5%)',
                          answer: {
                            label: 'How effective was this (1-10 scale)',
                            type: 'number',
                            name: 'tactuPumplEffect',
                            min: 1,
                            max: 10
                          }
                        },
                        {
                          //5
                          key: 'differin',
                          value: 'Differin (Adapalene 0.1%)',
                          answer: {
                            label: 'How effective was this (1-10 scale)',
                            type: 'number',
                            name: 'differinEffect',
                            min: 1,
                            max: 10
                          }
                        },
                        {
                          //6
                          key: 'aczone',
                          value: 'Aczone (Dapsone 5%)',
                          answer: {
                            label: 'How effective was this (1-10 scale)',
                            type: 'number',
                            name: 'aczoneEffect',
                            min: 1,
                            max: 10
                          }
                        },
                        {
                          //7
                          key: 'biacna',
                          value: 'Biacna (Tretinoin 0.025%+ clindamycin 1.2%)',
                          answer: {
                            label: 'How effective was this (1-10 scale)',
                            type: 'number',
                            name: 'biacnaEffect',
                            min: 1,
                            max: 10
                          }
                        },
                        {
                          //8
                          key: 'retin',
                          value: 'Retin -A  (tretinoin - various strengths)',
                          answer: {
                            label: 'How effective was this (1-10 scale)',
                            type: 'number',
                            name: 'retinEffect',
                            min: 1,
                            max: 10
                          }
                        },
                        {
                          //9
                          key: 'doxycycline',
                          value: 'Doxycycline or Minocycline Oral pills',
                          answer: {
                            label: 'How effective was this (1-10 scale)',
                            type: 'number',
                            name: 'doxycyclineEffect',
                            min: 1,
                            max: 10
                          }
                        },
                        {
                          //10
                          key: 'accutane',
                          value: 'Accutane (Isotretinoin) pills',
                          answer: {
                            label: 'How effective was this (1-10 scale)',
                            type: 'number',
                            name: 'accutaneEffect',
                            min: 1,
                            max: 10
                          }
                        },
                        {
                          //11
                          key: 'finacea',
                          value: 'Finacea (Azelaic Acid) (adult acne/rosacea)'
                        },
                        {
                          //12
                          key: 'birthPills',
                          value: 'Birth Control pills',
                          answer: {
                            label: 'How effective was this (1-10 scale)',
                            type: 'number',
                            name: 'birthPillsEffect',
                            min: 1,
                            max: 10
                          }
                        },
                        {
                          //13
                          key: 'acneOther',
                          value: 'Other',
                          answer: {
                            label: 'Please describe',
                            type: 'text',
                            name: 'acneOtherDesc'
                          }
                        }
                      ]
                    },
                    {
                      label:
                        'Are you looking to continue with what you are used to?',
                      type: 'radio',
                      name: 'backOrContinue',
                      options: [
                        {
                          key: 'backOrContinueYes',
                          value: 'Yes',
                          answer: {
                            label: 'Please provide details on which ones',
                            type: 'text',
                            name: 'backOrContinueYesDesc'
                          }
                        },
                        {
                          key: 'backOrContinueNo',
                          value: 'No',
                          answer: {
                            label:
                              'Please provide details on what you are looking for this is a bit vague?',
                            type: 'text',
                            name: 'backOrContinueNoDesc'
                          }
                        }
                      ]
                    }
                  ]
                }
              }
            ]
          }
        }
      ],
      fullWidth: true
    }
  },
  {
    //2
    label:
      'Have you ever tried over the counter treatments (non-prescription) treatments for your Acne?',
    field: 'counterTreatment',
    type: 'polar_check',
    answer: {
      label: 'Please list what you have tried',
      type: 'multi_select',
      options: [
        {
          //1
          key: 'benzagelWash',
          value: 'Benzagel Wash (5% benzoyl peroxide)',
          answer: {
            label: 'How effective was this (1-10 scale)',
            type: 'number',
            name: 'benzagelWashEffect',
            min: 1,
            max: 10
          }
        },
        {
          //2
          key: 'oxyPads',
          value: 'Oxy Pads (Salicylic acid 0.5%-2%)',
          answer: {
            label: 'How effective was this (1-10 scale)',
            type: 'number',
            name: 'oxyPadsEffect',
            min: 1,
            max: 10
          }
        },
        {
          //3
          key: 'clearasil',
          value: 'Clearasil (Salicylic acid 0.5% - 2%)',
          answer: {
            label: 'How effective was this (1-10 scale)',
            type: 'number',
            name: 'clearasilEffect',
            min: 1,
            max: 10
          }
        },
        {
          //4
          key: 'counterTreatmentOther',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'counterTreatmentOtherDesc',
            placeholder: 'Please describe'
          }
        }
      ]
    }
  },
  {
    //3
    label: 'How would you best describe your skin type?',
    field: 'bestSkinType',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'veryDry', value: 'Very Dry' },
        { key: 'somewhatDry', value: 'Somewhat Dry' },
        { key: 'oftenDry', value: 'Often Dry' },
        { key: 'veryOily', value: 'Very Oily' },
        { key: 'mixedType', value: 'Mixed type' }
      ]
    }
  },
  {
    //4
    label: 'Do you put sunscreen on your face (anything with SPF counts too)',
    field: 'sunscreen',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'always', value: 'Always' },
        { key: 'mostTime', value: 'Most of the time' },
        { key: 'sometimes', value: 'Sometimes' },
        { key: 'never', value: 'Never' }
      ]
    }
  },
  {
    //5
    label: 'What parts of your body are affected by Acne? ',
    field: 'affectedParts',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'face', value: 'Face' },
        { key: 'back', value: 'Back' },
        { key: 'chest', value: 'Chest' },
        {
          key: 'other',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'otherPart',
            placeholder: 'describe'
          }
        }
      ]
    }
  },
  {
    //6
    label:
      'Are you pregnant, breastfeeding, or planning to become pregnant in the near future?',
    field: 'pregnantFuture',
    type: 'polar_check',
    answer: {
      label: 'Please tell us more about your plans',
      name: 'pregnantFutureDesc',
      type: 'text'
    }
  },
  {
    //7
    label:
      'Have you had a skin reaction to any of the topical products you have used in the past?',
    field: 'skinReaction',
    type: 'polar_check',
    answer: {
      label:
        'Describe the type of reaction you had and as much detail about the product that caused the reaction',
      name: 'skinReactionDesc',
      type: 'text'
    }
  },
  {
    //8
    label: 'Have you ever been diagnosed with any of the following?',
    field: 'diagnosed',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'rosacea', value: 'Rosacea' },
        { key: 'dermatitis', value: 'Perioral dermatitis' },
        { key: 'facialEczema', value: 'Facial eczema' },
        { key: 'bacterial', value: 'Bacterial or fungal folliculitis' },
        {
          key: 'neverDiagnosed',
          value: 'No, never had any of these',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    //9
    label: 'Is there anything else you would like the doctor to know?',
    field: 'elseAcne',
    type: 'info',
    answer: {
      type: 'text',
      name: 'elseAcneDesc',
      placeholder: 'Please describe'
    }
  },
  {
    field: 'skinAcknowledgement',
    label:
      'I agree to have my relevant prescription information transferred to IHS Compounding Pharmacy. The information shared will be kept strictly confidential in accordance with the Ontario College of Pharmacists` regulations.',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [{ key: 'skinAcknowledgement', value: 'I Agree' }]
    }
  }
];

export default questionsModels;
